// 字节跳动 Seed 语音音色列表
export const seedSpeechVoices: string[] = [
  'stokie_en',
  'dacey_en',
  'tim_en',
  'kian_en_zh',
  'cedric_en_zh',
  'sophie_en_zh',
  'jean_en_zh',
  'magnus_en_zh',
  'mabel_en_zh',
  'nadia_en_zh',
  'opal_en_zh',
  'pearl_en_zh',
  'quentin_en_zh',
  'vienna_mixed_en_zh',
  'alina_mixed_en_zh',
  'corinne_mixed_en_zh',
  'esther_mixed_en_zh',
  'freya_mixed_en_zh',
  'gigi_mixed_en_zh',
  'holly_mixed_en_zh',
  'lyla_mixed_en_zh',
  'daisy_mixed_en_zh',
  'tracy_es_zh',
  'vivi_mixed_en_zh_ja_es_id',
  'mindy_en_es_id_pt_zh',
  'jess_ja_es_id_pt_en_zh',
  'pinky_es_ko_mixed_en_zh',
  'sweety_ja_es',
  'sandy_es_mixed_en_zh',
  'sven_de',
  'minimi_ja',
  'usseau_fr',
  'felipe_es',
  'han_id',
  'martins_pt',
  'enzo_it',
  'shane_ko',
  'bonnie_zh',
  'felix_zh',
  'celeste_zh',
  'monkey_king_zh',
];